import { defineComponent } from "vue";
import { SdkRole } from "@/interfaces/sdk-role";
import { loadAllRole } from "@/store/role/actions";
import SdkFormsSearch from "@/components/sdk-forms/sdk-forms-search/sdk-forms-search.vue";
import { sort } from "@/utils/array-functions";

export default defineComponent({
  name: "sdk-forms-role",
  components: {
    SdkFormsSearch,
  },
  data() {
    return {
      loading: false,
      formData: { id: undefined, name: "", permissions: [{ id: undefined }] } as SdkRole,
      roles: [] as SdkRole[],
      list: [] as SdkRole[],
    };
  },
  computed: {
    filteredList(): SdkRole[] {
      return sort(this.list, false, "name");
    },
  },
  methods: {
    startCreation() {
      this.$router.push({ name: "role", params: { role: "new" } });
    },
    async fetchRoles() {
      await this.$dispatch(loadAllRole)().then((data: SdkRole[]) => {
        this.roles = data;
        this.list = data;
      });
    },
    filterResult(value: string) {
      this.list = this.roles.filter((f: any) => f.name.toLowerCase().indexOf(value.toLowerCase().trim()) !== -1);
    },
  },
  async mounted() {
    this.loading = true;
    await this.fetchRoles();
    this.loading = false;
  },
});
